import { percentToMicroWithPrecision } from '@openx/utils/lib/percentToMicro.ts';
import type { CuratedDealBuyerDiscountApiPayload } from '../../../../types/curatedDealBuyerDiscount.ts';
import { type CuratedDealBuyerDiscountsFormData, curatedDealBuyerDiscountApplyTo } from '../types.ts';

export const createCuratedDealBuyerDiscountApiPayload = (
  accountUid: string,
  formData: CuratedDealBuyerDiscountsFormData
): CuratedDealBuyerDiscountApiPayload => {
  const isAppliedToDemandPartner = formData.apply_to === curatedDealBuyerDiscountApplyTo.DemandPartner;

  return {
    account_uid: accountUid,
    banner_and_video_discount: percentToMicroWithPrecision(formData.banner_and_video_discount),
    ctv_discount: percentToMicroWithPrecision(formData.ctv_discount),
    demand_partner_id: isAppliedToDemandPartner ? formData.demand_partner?.id : null,
    name: formData.name,
    seat_ids: isAppliedToDemandPartner ? null : Object.keys(formData.seat_ids),
  };
};
